import { Box, Button } from '@mui/material';
import { t } from 'i18next';
import { TextField } from '@mui/material';
import { PRIMARY_LIGHT_SECONDARY } from 'constants/colors';
import { useState } from 'react';
import useAddRequestNote from '../hooks/useAddRequestNote';

type NoteFormProps = {
  requestId: number;
  setShowNoteForm: (show: boolean) => void;
  isWebSocketEnabled?: boolean;
};

const NoteForm = ({
  requestId,
  setShowNoteForm,
  isWebSocketEnabled = false
}: NoteFormProps) => {
  const [noteContent, setNoteContent] = useState('');
  const { mutateAsync: createRequestNote, isLoading: isLoadingRequestNote } =
    useAddRequestNote({ isWebSocketEnabled });

  const handleSave = () => {
    if (noteContent.trim()) {
      createRequestNote(
        {
          body: {
            note: {
              content: noteContent,
              flags: [],
              refId: requestId
            }
          }
        },
        {
          onSuccess: () => {
            setNoteContent('');
            setShowNoteForm(false);
          }
        }
      );
    }
  };

  return (
    <>
      <TextField
        minRows={6}
        multiline
        value={noteContent}
        onChange={(e) => setNoteContent(e.target.value)}
        sx={{
          backgroundColor: PRIMARY_LIGHT_SECONDARY,
          '& .MuiInputBase-inputMultiline': {
            padding: 2
          }
        }}
      />
      <Box display="flex" justifyContent="end" gap={1}>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          sx={{ width: 'max-content' }}
          disabled={isLoadingRequestNote}
        >
          {t('save')}
        </Button>
      </Box>
    </>
  );
};

export default NoteForm;
